'use client';

import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

export const STORAGE_KEY = 'deployment-toasts';
export const TOAST_DURATION_MS = 1.5 * 60 * 1000; // 1.5 minutes

type Toast = {
    id: string;
    label: string;
    timestamp: number;
};

export const useDeploymentToasts = () => {
    const [toasts, setToasts] = useState<Toast[]>([]);

    useEffect(() => {
        const load = () => {
            const now = Date.now();
            // Check for active deployment cookie
            const cookie = Cookies.get('waiting-for-deploy');
            let cookieToast: Toast[] = [];

            if (cookie) {
                try {
                    const parsed = JSON.parse(cookie);
                    if (parsed?.locale && parsed?.contentHash) {
                        cookieToast = [{
                            id: 'waiting-for-deploy',
                            label: `Déploiement en cours pour "${parsed?.contentHash}"...`,
                            timestamp: now
                        }];
                    }
                } catch (err) {
                    console.warn('⚠️ Invalid waiting-for-deploy cookie');
                }
            }

            setToasts([...cookieToast]);
        };

        load();
        const interval = setInterval(load, 5000);
        return () => clearInterval(interval);
    }, []);

    return toasts;
};
